import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import EventCodeList from './EventCodeList';
import {
  getEventCode,
  getUserProfileWidget,
  getCurrentTimezone,
  getUserOrgModelCategoryType
} from '../../selectors/index';
import { getEventCodeThunk, setCurrentPage, setPageFilter, setFilteredDataThunk, eventCodeCleanUpThunk } from '../../actions/eventCode';

const mapStateToProps = state => {
  return {
    eventCodeManager: getEventCode(state),
    userProfileWidgets: getUserProfileWidget(state),
    currentTimezone: getCurrentTimezone(state),
    userModelCategories: getUserOrgModelCategoryType(state)

  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getEventCodes: modelCategoryId => getEventCodeThunk('EVENTCODES_TAB', modelCategoryId),
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter),
      setFilterData: filteredData => setFilteredDataThunk(filteredData),
      cleanUp: initialData => eventCodeCleanUpThunk(initialData)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EventCodeList);
